"use client";

import React from "react";
import { useLoading } from "@context/LoadingContext";
import GlobalLoader from "@components/atoms/GlobalLoader/GlobalLoader";
import { inApp } from "@utils/platformDetection.client";
import { resolveGlobalLoaderConfig } from "./globalLoaderOverlayConfig";

interface GlobalLoaderOverlayProps {
  size?: "small" | "medium" | "large";
}

const GlobalLoaderOverlay: React.FC<GlobalLoaderOverlayProps> = ({
  size = "large",
}) => {
  const { isLoading, loadingText, loaderVariant } = useLoading();
  const loaderConfig = resolveGlobalLoaderConfig({
    isInApp: inApp(),
    loadingText,
    requestedVariant: loaderVariant,
    defaultSize: size,
  });

  return (
    <GlobalLoader
      isLoading={isLoading}
      overlay={true}
      overlayClassName={loaderConfig.overlayClassName}
      textClassName={loaderConfig.textClassName}
      text={loaderConfig.text}
      size={loaderConfig.size}
      variant={loaderConfig.variant}
    />
  );
};

export default GlobalLoaderOverlay;
